class VwKurumMailGonderimAyarlariDTO {

    id: number = null;
    fkOrganizasyon: number = null;
    fkKurum: number = null;
    mailAdres: string = null;
    gonderimYontem: number = 1;
    gonderimSureYontem: number = null;
    gonderimSure: number = null;
    gonderimAktif?: string = "E";
    eklemeTarihi?: string = null;
    ekleyenKullanici: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici: number = null;
    organizasyonAdi?: string = "";
    kurumAdi?: string = "";
    gonderimYontemDetay?: string = "";
    gonderimSureYontemDetay?: string = "";



}

export default VwKurumMailGonderimAyarlariDTO